var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-shipping-fee"},[_c('edit',{ref:"edit",attrs:{"api":'settings',"fs":_vm.paymentFields,"id":'shipping-fee',"title":"Deliver Fee Settings"},on:{"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }